module.exports = __webpack_public_path__ + "static/media/bitmap-media-1@1x.62c49f79.png";